<template>
    <footer class="footer">
		<div class="container">
			<div class="row align-items-center">
				<div class="col-md-4">
				  <span class="copyright">Tous droits réservés &copy; <a href="https://gabriel-cassano.be/">Gabriele Cassano</a></span>
				</div>
				
				<div class="col-md-4">
				  <ul class="list-inline social-buttons">
					<li class="list-inline-item">
					  <a href="https://twitter.com/jaymbo78">
						<i class="fab fa-twitter"></i>
					  </a>
					</li>
					<li class="list-inline-item">
					  <a href="https://www.facebook.com/profile.php?id=100010505551221">
						<i class="fab fa-facebook-f"></i>
					  </a>
					</li>
					<li class="list-inline-item">
					  <a href="https://be.linkedin.com/in/gabriele-cassano-57403958">
						<i class="fab fa-linkedin-in"></i>
					  </a>
					</li>
				  </ul>
				</div>			
			 </div>
		</div>
	</footer>	 
</template>

<script>
export default {

}
</script>

<style lang="css">

</style>


